@let application = result();

<div
  (click)="openApplication(application)"
  class="group relative flex items-center justify-center gap-2 w-full cursor-pointer"
>
  <span
    class="flex items-center justify-center rounded-md min-w-8 min-h-8 text-center content-center hover:bg-surface-tertiary bg-surface-secondary"
  >
    @if (application?.icon !== '') {
    <soft-icon
      [name]="$safeNavigationMigration(application?.icon)"
      class="text-sm"
      [class]="application?.disabled ? 'text-lighter' : ''"
    />
    } @else {
    <i class="fa-regular fa-ban"></i>
    }
  </span>
  <div class="flex flex-row items-center gap-1.5 w-full text-start set-width">
    <span
      class="text-sm font-semibold text-start"
      [class]="application?.disabled ? 'text-lighter' : ''"
    >
      {{ $safeNavigationMigration(application?.name) | translate }}
    </span>
    @if (application?.type === 'link') {
    <span
      class="text-[9px] font-medium bg-surface-secondary text-light rounded-full px-1.5 py-px shrink-0 flex items-center gap-0.5"
    >
      <i class="fa-regular fa-arrow-up-right-from-square text-[9px]"></i>
      Externer Link
    </span>
    }
  </div>
  @if (canPin()) {
  <button
    type="button"
    class="opacity-0 group-hover:opacity-100 flex items-center justify-center size-7 rounded-md hover:bg-surface-tertiary transition-opacity shrink-0 cursor-pointer"
    [class.opacity-100]="isPinned()"
    (click)="togglePin($event)"
    [title]="isPinned() ? 'Aus Navigation entfernen' : 'An Navigation anheften'"
  >
    <i
      class="fa-thumbtack text-xs transition-transform"
      [class.fa-solid]="isPinned()"
      [class.fa-regular]="!isPinned()"
      [class.text-primary]="isPinned()"
      [class.rotate-45]="isPinned()"
    ></i>
  </button>
  }
  <button
    type="button"
    class="opacity-0 group-hover:opacity-100 flex items-center justify-center size-7 rounded-md hover:bg-surface-tertiary transition-opacity shrink-0 cursor-pointer"
    (click)="openInNewTab(application, $event)"
    title="In neuem Tab öffnen"
  >
    <i class="fa-regular fa-arrow-up-right-from-square text-xs"></i>
  </button>
</div>
